import styled from "@emotion/styled";
import { TagsSkeleton } from "./TagsSkeleton";
import { ChanneResultsSkeleton } from "./ChanneResultsSkeleton";
import { GalleryResultsSkeleton } from "./GalleryResultsSkeleton";
import { CategoryLinksSkeleton } from "./CategoryLinksSkeleton";
import { MediaCardSkeleton } from "@kaltura/mediaspace-shared-media-card";

const StyledEntrySkeleton = styled(MediaCardSkeleton)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

/**
 * global search results skeleton
 */
export function SearchResultsSkeleton() {
    return (
        <>
            <TagsSkeleton />
            <StyledEntrySkeleton />
            <StyledEntrySkeleton />
            <StyledEntrySkeleton />
            <CategoryLinksSkeleton />
            <ChanneResultsSkeleton />
            <CategoryLinksSkeleton />
            <GalleryResultsSkeleton />
            <StyledEntrySkeleton />
        </>
    );
}

export default SearchResultsSkeleton;
